import { render, staticRenderFns } from "./waybill.vue?vue&type=template&id=f1cff318&scoped=true&"
import script from "./waybill.vue?vue&type=script&lang=js&"
export * from "./waybill.vue?vue&type=script&lang=js&"
import style0 from "./waybill.vue?vue&type=style&index=0&id=f1cff318&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cff318",
  null
  
)

export default component.exports